<div nz-row>
  <div nz-col nzSpan="24" style="margin-bottom: 1rem;" class="no-form">
    <h1 i18n="Identity.AccessLog.Title|title for access log page@@Identity.AccessLog.Title">Ultimi accessi</h1>
  </div>
</div>

<nz-spin nzTip="Download dei dati..." [nzSpinning]="isSpinning">
  <nz-table #logsTable [nzData]="listOfData" [nzFrontPagination]='false' nzTableLayout="fixed">
    <thead>
      <tr>
        <th *ngFor="let column of listOfColumns ; index as i" [nzLeft]="i < lockLeft"
          [nzRight]="i >= listOfColumns.length - lockRight" nzEllipsis><span class="cell-content">
            {{ column.name }} </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of logsTable.data">
        <td [nzLeft]="0 < lockLeft" [nzRight]="0 >= listOfColumns.length - lockRight" nzEllipsis><span
            class="cell-content">{{ data.date | date:'dd/MM/YYYY HH:mm'}}</span></td>
        <td [nzLeft]="1 < lockLeft" [nzRight]="1 >= listOfColumns.length - lockRight" nzEllipsis><span
            class="cell-content">
            <p class="highlight">{{ data.level }}</p>
          </span></td>
        <td [nzLeft]="2 < lockLeft" [nzRight]="2 >= listOfColumns.length - lockRight" nzEllipsis><span
            class="cell-content">{{ data.address }}</span></td>
        <td [nzLeft]="3 < lockLeft" [nzRight]="3 >= listOfColumns.length - lockRight" nzEllipsis>
          <span class="cell-content">
            <a nz-button i18n="Identity.AccessLog.SamlDetail|detail for saml@@Identity.AccessLog.SamlDetail"
              (click)="showModal(samlModal, data.assertion)">Dettaglio</a>
          </span>
        </td>
        <td [nzLeft]="4 < lockLeft" [nzRight]="4 >= listOfColumns.length - lockRight" nzEllipsis><span
            class="cell-content">{{ data.spname }}</span></td>
        <td [nzLeft]="5 < lockLeft" [nzRight]="5 >= listOfColumns.length - lockRight" nzEllipsis><span
            class="cell-content"><a>{{ data.spuri }}</a></span></td>
        <td [nzLeft]="6 < lockLeft" [nzRight]="6 >= listOfColumns.length - lockRight" nzEllipsis><span
            class="cell-content"> <img class="status-icon" [src]="getStatusIcon(data.result)">
            {{ getStatusDisplay(data.result) }} </span></td>
      </tr>
    </tbody>
  </nz-table>
  <div *ngIf="this.listOfData?.length">
    <nz-row nzJustify="end">
      <p>Pagina {{ page }} di {{ pages }}</p>
    </nz-row>
    <nz-row nzJustify="end">
      <button nz-button nzType="default" [disabled]="!prev" (click)="onPrev()">&lt;</button>
      <button nz-button nzType="default">{{page}}</button>
      <button nz-button nzType="default" [disabled]="!next" (click)="onNext()">&gt;</button>
    </nz-row>
  </div>
</nz-spin>

<ng-template #samlModal let-params let-ref="modalRef">
  <p>{{samlDetail}}</p>
</ng-template>